import React from "react";

const CASES = [
  { key: "avant-vente", kicker: "Avant-vente", title: "Répondre à une opportunité urgente", desc: "Trouver les profils alignés, préparer les CV et structurer la shortlist." },
  { key: "staffing", kicker: "Staffing", title: "Identifier la bonne disponibilité", desc: "Visualiser les compétences et accélérer les arbitrages internes." },
  { key: "direction", kicker: "Direction", title: "Lire la capacité commerciale", desc: "Mieux comprendre l'offre de compétences mobilisable à court terme." },
  { key: "partenaires", kicker: "Partenaires", title: "Activer le bon réseau", desc: "Garder les partenaires utiles accessibles, qualifiés et actionnables." },
];

const Cas = () => (
  <section className="mk-section" id="cas" data-testid="section-cas">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2>Des parcours pensés pour le quotidien des ESN.</h2>
        </div>
      </div>
      <div className="mk-usecases">
        {CASES.map((c) => (
          <article key={c.key} className="mk-case mk-reveal">
            <b>{c.kicker}</b>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Cas;
